function Footer () {
    return (
        <section className="footer card">
            <div className="footer--container">
                 <a href="x"><img src="./Twitter.png" alt="twitter"/></a>
                 <a href="x"><img src="./Facebook.png" alt="fb"/></a>
                 <a href="x"><img src="./Instagram.png" alt="instagram"/></a>
                 <a href="https://github.com/Pxavier263"><img src="./GitHub.png" alt="gitHub"/></a>
             </div>
         </section>
    )
};
export default Footer;

